import ApplicationsToBeReviewed from './ApplicationsToBeReviewed';

export default ApplicationsToBeReviewed;
